import React from "react";
import ContactForm from "./pages/ContactForm";
import ContactFormOverview from "./pages/ContactFormOverview";
import {useGlobalContext} from "./contexts/GlobalContext";

export const routes = {
    'overview': <ContactFormOverview/>,
    'ContactForm': <ContactForm/>,
} as const

export type ZrLink = {
    name: string;
    route: keyof typeof routes;
}

const ZrRouter: React.FC = () => {
    const { useRoute: {route}} = useGlobalContext()

    return (
        routes[route]
    )
}

export default ZrRouter
